import {
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_FAIL,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  EXPORT_USER_EXCEL_SUCCESS,
  EXPORT_USER_EXCEL_FAIL,
  RESET_USER_STATE,
  UPDATE_ACTIVATION_USER_SUCCESS,
  UPDATE_ACTIVATION_USER_FAIL,
  RESET_USER_ACTION_STATE,
  UPDATE_DEPARTMENT_USER_FAIL,
  UPDATE_DEPARTMENT_USER_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  userListing: [],
  userDetails: [],
  addUser: [],
  editUser: [],
  editUserActivation: [],
  editUserDepartment: [],
  delUser: [],
  exportExcel: [],
}

const User = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_SUCCESS:
      return {
        ...state,
        userListing: action.payload,
      }

    case GET_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: action.payload,
      }

    case GET_USER_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_USER_SUCCESS:
      return {
        ...state,
        addUser: action.payload,
        userDetails: action.payload.data,
      }

    case ADD_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        addUser: action.payload,
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        editUser: action.payload,
        userDetails: action.payload.data,
      }

    case UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        editUser: action.payload,
      }

    case UPDATE_ACTIVATION_USER_SUCCESS:
      return {
        ...state,
        editUserActivation: action.payload,
      }

    case UPDATE_ACTIVATION_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_DEPARTMENT_USER_SUCCESS:
      return {
        ...state,
        editUserDepartment: action.payload,
      }

    case UPDATE_DEPARTMENT_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        delUser: action.payload
      }

    case DELETE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
        delUser: action.payload
      }

    case EXPORT_USER_EXCEL_SUCCESS:
      return {
        ...state,
        exportExcel: action.payload
      }

    case EXPORT_USER_EXCEL_FAIL:
      return {
        ...state,
        exportExcel: action.payload,
      }
    case RESET_USER_STATE:
      return {
        ...state,
        userListing: [],
        userDetails: [],
        addUser: [],
        editUser: [],
        editUserActivation: [],
        editUserDepartment: [],
        delUser: [],
        error: [],
        exportExcel: [],
      }
    case RESET_USER_ACTION_STATE:
      return {
        ...state,
        addUser: [],
        editUser: [],
        editUserActivation: [],
        editUserDepartment: [],
        delUser: [],
        error: [],
        exportExcel: [],
      }
    default:
      return state
  }
}

export default User
